import axios from "@/plugins/axios"
import type { Country } from "@/types/country.type"

async function countries(): Promise<Country[]> {
  const response = await axios.get<Country[]>("/countries")
  return response.data
}

const countryService = {
  countries,
}

export default countryService
